module.exports = __webpack_public_path__ + "img/star_2.652816c1.jpg";